import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=c1160cf4&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=c1160cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1160cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1160cf4')) {
      api.createRecord('c1160cf4', component.options)
    } else {
      api.reload('c1160cf4', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=c1160cf4&scoped=true&", function () {
      api.rerender('c1160cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-86KHDcCh95T0h/JS/comp/DateRangeExt.vue"
export default component.exports